import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Generated class for the TextPagerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'text-pager',
  templateUrl: 'text-pager.html',
})
export class TextPagerComponent implements OnInit {
  @Input() curPage: any;
  @Input() pages: Array<any>;
  @Input() pageCounts: Array<any> = [];

  @Output() onPageChange = new EventEmitter();

  constructor() {
    console.log('Hello TextPagerComponent Component');
  }

  changePage(page) {
    this.curPage = page;
    this.onPageChange.emit(page);
  }

  ngOnInit(): void {}
}



// WEBPACK FOOTER //
// ./src/components/text-pager/text-pager.ts